var map = {
	"./add-wallet.png": "6xn9",
	"./all-page.svg": "Nz/5",
	"./arrows-maximize.svg": "ufRA",
	"./avatar/Ellipse42.png": "J7V8",
	"./avatar/store.png": "FoAh",
	"./bank/baac.png": "yCg9",
	"./bank/bay.png": "RRSd",
	"./bank/bbl.png": "9a1T",
	"./bank/cimb.png": "i+Aq",
	"./bank/ghb.png": "4mBp",
	"./bank/gsb.png": "KteS",
	"./bank/ibank.png": "C1gS",
	"./bank/icbc.png": "mg+6",
	"./bank/kbank.png": "MOE8",
	"./bank/kk.png": "0td9",
	"./bank/ktb.png": "KiQr",
	"./bank/lhb.png": "0xBg",
	"./bank/none.png": "AAwx",
	"./bank/sc.png": "9pLU",
	"./bank/scb.png": "chyL",
	"./bank/tbank.png": "jrNC",
	"./bank/tisco.png": "ivCk",
	"./bank/tmb.png": "BNqE",
	"./bank/uob.png": "g65J",
	"./calendar-12.svg": "O8x6",
	"./calendar-alt-regular-515151.svg": "M/G1",
	"./calendar-alt-regular-999.svg": "Nxc3",
	"./calendar-disconnected-page.svg": "GDbh",
	"./carrier/4.png": "L/vp",
	"./carrier/450px.png": "lSVw",
	"./carrier/5.png": "xz2H",
	"./carrier/550px.png": "bbx9",
	"./carrier/6.png": "kyb9",
	"./carrier/650px.png": "2oPy",
	"./carrier/8.png": "YuRF",
	"./carrier/850px.png": "1Dsv",
	"./carrier/FLASH_EXPRESS.png": "G3Iw",
	"./carrier/KERRY_EXPRESS.png": "9rMM",
	"./carrier/THAIPOST.png": "pc+J",
	"./carrier/_4.png": "Ql42",
	"./carrier/_5.png": "3D6F",
	"./carrier/_6.png": "lvDy",
	"./carrier/_8.png": "zr0V",
	"./carrier/_THAIPOST.png": "gjai",
	"./carrier/__6.png": "DoGP",
	"./carrier/___5.png": "AEuf",
	"./carrier/i-dhl.png": "96UE",
	"./carrier/i-jt.png": "CW8N",
	"./channel/1.png": "bCfX",
	"./channel/10.png": "tm8i",
	"./channel/11.png": "MfMV",
	"./channel/2.png": "1P7/",
	"./channel/3.png": "kVfp",
	"./channel/9.png": "n9OC",
	"./channel/Application.png": "MI9l",
	"./channel/Salepage.png": "ZEbH",
	"./channel/Telesales.png": "ligH",
	"./circle-exclamation-alert.svg": "BrI7",
	"./clock-12.svg": "5UP8",
	"./code-pull-request-draft-solid-515151.svg": "HJFL",
	"./comment-alt-lines-regular.svg": "FETF",
	"./connections/connection_failed.png": "rUbE",
	"./connections/connection_success.png": "H8wL",
	"./connections/connection_waiting.png": "vVsg",
	"./copy-duotone-dark.svg": "E3tj",
	"./copy-duotone.svg": "pjL2",
	"./credit-card-support.png": "1nyA",
	"./draganddropfile.svg": "xXyZ",
	"./dummy/Rectangle1242.png": "McXu",
	"./dummy/channel/laz.png": "XOOh",
	"./dummy/channel/shop.png": "Tri6",
	"./dummy/demo_profile.png": "NQDU",
	"./dummy/payment/Group206.png": "iAo3",
	"./dummy/payment/Group3731.png": "lnkv",
	"./dummy/payment/bangkok.png": "2xbf",
	"./dummy/payment/kbank.png": "9qW0",
	"./dummy/product/product1.png": "1Rby",
	"./dummy/product/product2.png": "dIRl",
	"./dummy/product/product3.png": "gDvD",
	"./dummy/shipping/DHL.png": "Grh5",
	"./dummy/shipping/JT.png": "WGwl",
	"./dummy/user-profile.png": "xnM1",
	"./dummy/user.png": "yt9J",
	"./edit-user-blue.svg": "YEJT",
	"./ellipsis-v-regular.svg": "7alL",
	"./envelope-solid-515151.svg": "ACNf",
	"./face-smile-solid-dark.svg": "h6tz",
	"./face-smile-solid.svg": "wewC",
	"./file-image.png": "Mo+f",
	"./floppy-disk-solid.svg": "LCSr",
	"./frontend/email_sent.gif": "dl5I",
	"./frontend/integration_channel/1.png": "T/6n",
	"./frontend/integration_channel/2.png": "o9GD",
	"./frontend/integration_channel/3.png": "axyN",
	"./frontend/integration_channel/Application.png": "/rdF",
	"./frontend/integration_channel/Salepage.png": "NYM/",
	"./frontend/integration_channel/Telesales.png": "FIaL",
	"./frontend/integration_channel/Tiktok.png": "yiDq",
	"./frontend/integration_channel/instagram.png": "Sf99",
	"./frontend/integration_channel/youtube-square-brands 2.png": "k8rX",
	"./frontend/logo/_logo.png": "QUcE",
	"./frontend/logo/logo.png": "C+ms",
	"./globe-asia-regular-515151.svg": "bUpE",
	"./house-solid-515151.svg": "d14+",
	"./img-sms.png": "9sjM",
	"./integration/1.png": "D6Jk",
	"./integration/2.png": "jmgs",
	"./integration/3.png": "ux60",
	"./integration/Application.png": "bPlq",
	"./integration/Salepage.png": "BOaQ",
	"./integration/Telesales.png": "YTvp",
	"./integration/Tiktok.png": "c11D",
	"./integration/instagram.png": "0BAw",
	"./integration/youtube-square-brands 2.png": "qD4C",
	"./lang/en-US.png": "aXBa",
	"./lang/en.png": "MiCS",
	"./lang/th.png": "1D3S",
	"./line-brands-515151.svg": "XIjQ",
	"./logo.png": "iQH9",
	"./logo.svg": "zxL1",
	"./mobile-alt-solid-515151.svg": "m3C2",
	"./no-image-2.png": "+oEG",
	"./no-image-3.png": "0FYu",
	"./no-image-6.png": "k6hH",
	"./no-image-label.png": "KBYp",
	"./no-image-profile.png": "1eI5",
	"./no-image.png": "xxmW",
	"./no-msg.svg": "4hO1",
	"./no_label.jpeg": "r0bz",
	"./payment/1.png": "vRJy",
	"./payment/2.png": "KmS4",
	"./payment/3.png": "uHgC",
	"./payment/Bank transfer.png": "crti",
	"./payment/Cash.png": "e8fo",
	"./payment/Cod.png": "trVw",
	"./payment/Kbank_payment_logo.png": "9anU",
	"./payment/cod.svg": "yDoQ",
	"./payment/credit_card_support.png": "Uib6",
	"./payment/logo_Kbank.png": "olVk",
	"./payment/promptPay2.png": "Y8aU",
	"./payment/qr_code.png": "pHZL",
	"./pen-square-regular.svg": "6+9x",
	"./plus-circle-solid.svg": "TyAL",
	"./receipt-solid-515151.svg": "ABlT",
	"./reply-solid-dark.svg": "QhNL",
	"./reply-solid.svg": "SkAS",
	"./search-icon-bfbfbf.svg": "Vp/k",
	"./shipping/Failed_1.png": "J0sC",
	"./shipping/PromptPay2.png": "iyPs",
	"./shipping/thank_you_mail_1.png": "cyL2",
	"./tag-solid-515151.svg": "Liak",
	"./tag-solid.svg": "moWp",
	"./times-light.svg": "ARxs",
	"./trash-alt-regular.svg": "MDJr",
	"./user-circle-solid-515151.svg": "8312",
	"./user-cog-solid-515151.svg": "ejRb",
	"./user-edit-regular-999.svg": "jJ3I",
	"./users-solid-515151.svg": "no/s",
	"./venus-mars-solid-515151.svg": "PtDy",
	"./watting.png": "Swi7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 31